(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/components/market-research.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/components/market-research.js');
'use strict';

const {
  Fieldset
} = svs.ui.reactForm;
const {
  TopHeader
} = svs.myProfile.react.shared.components;
const {
  titles,
  icons
} = svs.myProfile.constants;

const MarketResearch = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement(TopHeader, {
    icon: icons.HELP,
    title: titles.HELP
  }), React.createElement("p", null, "Dina \xE5sikter \xE4r viktiga f\xF6r oss! Kan du t\xE4nka dig att delta i framtida kundunders\xF6kningar och hj\xE4lpa oss bli b\xE4ttre? Vi hj\xE4lper ocks\xE5 ibland forskare att rekrytera deltagare till seri\xF6sa forskningsprojekt om spelbeteende i Sverige. \xC4ndringar b\xF6rjar g\xE4lla n\xE4sta g\xE5ng du loggar in."), React.createElement(Fieldset, {
    legend: titles.HELP,
    srOnly: true
  }, children));
};
svs.myProfile.react.pages.communicationSettings.communicationSettings.components.MarketResearch = MarketResearch;

 })(window);